import { Card, Divider, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { enqueueSnackbar } from "notistack";
import { UseQueryResult } from "@tanstack/react-query";
import { GetPolicyDetailsForLeaseResponse } from "@safelease/service-utilities";
import { Formatters } from "@safelease/service-utilities";
import { Image } from "../../../image";

type PolicyDetailsProps = {
  policyDetailsQuery: UseQueryResult<GetPolicyDetailsForLeaseResponse>;
  showCancelDate?: boolean;
};

function PolicyDetails({ policyDetailsQuery, showCancelDate = false }: PolicyDetailsProps) {
  const { data: policyDetails, isError } = policyDetailsQuery;

  if (!policyDetails || isError) {
    enqueueSnackbar("Failed to load policy details", { variant: "error" });
    return null;
  }

  if (Object.keys(policyDetails).length === 0) {
    // Some leases don't have a policy associated with them
    return null;
  }

  return (
    <Card sx={{ padding: 2 }}>
      <Stack spacing={1}>
        <Stack direction={"row"} spacing={1} alignItems={"center"}>
          <Image alt="SafeLease logo" src="/images/logos/icon/safelease_logoicon_rgb_blueonwhite.svg" width={23} height={23} />
          <Typography sx={{ fontSize: 18 }}>Safelease Standard Plan</Typography>
        </Stack>
        <Divider />
        <Stack>
          <Typography>
            <span style={{ color: "#667085" }}>Enrolled</span>{" "}
            {policyDetails.policyStartDate ? dayjs(policyDetails.policyStartDate).format("MM/DD/YYYY") : "N/A"}
          </Typography>
          {showCancelDate && (
            <Typography>
              <span style={{ color: "#667085" }}>Cancelled</span>{" "}
              {policyDetails.policyEndDate ? dayjs(policyDetails.policyEndDate).format("MM/DD/YYYY") : "N/A"}
            </Typography>
          )}
          <Typography>
            <span style={{ color: "#667085" }}>Monthly Premium</span>{" "}
            {policyDetails.policyPremiumCents ? Formatters.penniesToDollars(policyDetails.policyPremiumCents) : "N/A"}
          </Typography>
          <Typography>
            <span style={{ color: "#667085" }}>Total Coverage</span>{" "}
            {policyDetails.policyCoverageCents ? Formatters.penniesToDollars(policyDetails.policyCoverageCents) : "N/A"}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
}

export { PolicyDetails };
